import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";

import QualifiedFormato from "./QualifiedFormato/QualifiedFormato";
import PositivityCategoryDesktop from "./QualifiedCoverage/QualifiedCoverageDesktop";
import SellOutTotal from "./SellOutTotal/SellOutTotal";

import InsightsDesktop from "./Insights/InsightsDesktop";
import SellOutDLX from "./SellOutDLX";
import Investigation from "./Investigation";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <div className="container-app">
          <LeftSideMenu app={app} config={config} />

          <Switch>
            <Route exact path="/">
              <Redirect to="/overview" />
            </Route>
            <Route
              path="/overview"
              exact
              render={() => <Overview app={app} config={config} />}
            />
            <Route
              path="/sell-out-total"
              exact
              render={() => <SellOutTotal app={app} config={config} />}
            />

            <Route
              path="/qualified-coverage"
              exact
              render={() => (
                <PositivityCategoryDesktop app={app} config={config} />
              )}
            />

            <Route
              path="/qualified-formato"
              exact
              render={() => <QualifiedFormato app={app} config={config} />}
            />

            <Route
              path="/sell-out-dlx"
              exact
              render={() => <SellOutDLX app={app} config={config} />}
            />

            {/* <Route
              path="/insights"
              exact
              render={() => <InsightsDesktop app={app} config={config} />}
            /> */}

            <Route
              path="/investigation"
              exact
              render={() => <Investigation app={app} config={config} />}
            />
          </Switch>
        </div>
      </HashRouter>
    </div>
  );
}

export default Layout;
